export enum LLMTemplateFormFields {
  CONTENT = 'content',
}

export type TLLMTemplateFormValues = {
  [LLMTemplateFormFields.CONTENT]: string;
};
